/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AuthenticationConfig} from '../models/AuthenticationConfig';
import type {Error} from '../models/Error';
import type {SentryConfig} from '../models/SentryConfig';

export interface GetAuthenticationConfig$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAuthenticationConfigRequest = createAction<PayloadData<void>>('CLIENT_CONFIG__GET_AUTHENTICATION_CONFIG__REQUEST');
export const getAuthenticationConfigSuccess = createAction<PayloadData<AuthenticationConfig>>('CLIENT_CONFIG__GET_AUTHENTICATION_CONFIG__SUCCESS');
export const getAuthenticationConfigFailure = createAction<PayloadData<Error, void, true>>('CLIENT_CONFIG__GET_AUTHENTICATION_CONFIG__FAILURE');

export const getAuthenticationConfigActions = [
    getAuthenticationConfigRequest,
    getAuthenticationConfigSuccess,
    getAuthenticationConfigFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAuthenticationConfig = (config?: GetAuthenticationConfig$Config) => {
    return {
        CALL_API: {
            types: getAuthenticationConfigActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/authentication-config`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSentryConfig$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSentryConfigRequest = createAction<PayloadData<void>>('CLIENT_CONFIG__GET_SENTRY_CONFIG__REQUEST');
export const getSentryConfigSuccess = createAction<PayloadData<SentryConfig>>('CLIENT_CONFIG__GET_SENTRY_CONFIG__SUCCESS');
export const getSentryConfigFailure = createAction<PayloadData<Error, void, true>>('CLIENT_CONFIG__GET_SENTRY_CONFIG__FAILURE');

export const getSentryConfigActions = [
    getSentryConfigRequest,
    getSentryConfigSuccess,
    getSentryConfigFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSentryConfig = (config?: GetSentryConfig$Config) => {
    return {
        CALL_API: {
            types: getSentryConfigActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sentry-config`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

